import * as actions from '..';

const invoicesReducerDefaultState = {
  items: [],
  filter: {},
  totalElements: 0,
  totalPages: 0,
  moonshotInvoiceFlag: false,
};

export const invoicesReducer = (
  state = invoicesReducerDefaultState,
  action
) => {
  switch (action.type) {
    case actions.ADD_INVOICES:
      return {
        ...state,
        items:
          action.payload.totalElements > 0 ? [...action.payload.invoices] : [],
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
      };
    case actions.CLEAR_INVOICES:
      return {
        ...state,
        items: [],
      };
    case actions.SET_DATE_FILTER:
      return {
        ...state,
        filter: {
          startDate: action.payload.startDate,
          toDate: action.payload.toDate,
          invoiceName: '',
        },
      };
    case actions.SET_INVOICE_NAME_FILTER:
      return {
        ...state,
        filter: {
          startDate: '',
          toDate: '',
          invoiceName: action.payload.invoiceName,
        },
      };
    case actions.SET_MOONSHOT_INVOICE_FLAG:
      return {
        ...state,
        moonshotInvoiceFlag: action.payload,
      };
    default:
      return state;
  }
};
